import { Vector3 } from 'three';

import { logger } from '@/modules/common/logging/logger';
import { Area } from '@/modules/floorplanDesign/types';

import { IDistconService } from './IDistconService';

export class DistconServiceExceptionDecorator implements IDistconService {
  private decoree: IDistconService;

  constructor(decoree: IDistconService) {
    this.decoree = decoree;
  }

  activateTool(): void {
    try {
      this.decoree.activateTool();
    } catch (err) {
      this.logError('activateTool distcon', err);
    }
  }

  cancelTool(): void {
    try {
      this.decoree.cancelTool();
    } catch (err) {
      this.logError('cancelTool distcon', err);
    }
  }

  startDistcon(area: Area, clickedPosition: Vector3): void {
    try {
      this.decoree.startDistcon(area, clickedPosition);
    } catch (err) {
      this.logError('startDistcon', err);
    }
  }

  endDistcon(area: Area, clickedPosition: Vector3): void {
    try {
      this.decoree.endDistcon(area, clickedPosition);
    } catch (err) {
      this.logError('endDistcon', err);
    }
  }

  private logError(methodName: string, error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    logger.error(`${methodName}: `, message);
  }
}
